exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AdDetailsMobileLoader__skeletonLoader___dEMjf > * {\n  background: linear-gradient(to right, rgba(255, 255, 255, 0), #f7f7f7 50%, rgba(255, 255, 255, 0) 80%), #f3f3f3;\n  background-repeat: repeat-y;\n  background-size: 50px 100%;\n  background-position: 0 0;\n  animation: AdDetailsMobileLoader__shine___1Sx_N 1s infinite; }\n\n@keyframes AdDetailsMobileLoader__shine___1Sx_N {\n  to {\n    background-position: 100% 0; } }\n\n.AdDetailsMobileLoader__imageWrapper___3yXXI {\n  height: 269px; }\n\n.AdDetailsMobileLoader__breadcrumb___YcaOo {\n  height: 20px;\n  margin: 20px 10px 20px; }\n\n.AdDetailsMobileLoader__heading___2vzlM {\n  margin: 23px 15px 10px;\n  height: 50px; }\n\n.AdDetailsMobileLoader__adInfo____8QcB {\n  margin: 0 15px 14px;\n  height: 27px;\n  width: 162px; }\n\n.AdDetailsMobileLoader__price___F2BHQ {\n  margin-inline: 15px;\n  width: 90px;\n  height: 50px; }\n\n.AdDetailsMobileLoader__location___3lpzH {\n  height: 50px;\n  width: 230px;\n  margin: 23px 15px 15px; }\n", ""]);

// exports
exports.locals = {
	"skeletonLoader": "AdDetailsMobileLoader__skeletonLoader___dEMjf",
	"shine": "AdDetailsMobileLoader__shine___1Sx_N",
	"imageWrapper": "AdDetailsMobileLoader__imageWrapper___3yXXI",
	"breadcrumb": "AdDetailsMobileLoader__breadcrumb___YcaOo",
	"heading": "AdDetailsMobileLoader__heading___2vzlM",
	"adInfo": "AdDetailsMobileLoader__adInfo____8QcB",
	"price": "AdDetailsMobileLoader__price___F2BHQ",
	"location": "AdDetailsMobileLoader__location___3lpzH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/AdDetailsMobileLoader/AdDetailsMobileLoader.scss
// module id = 4559
// module chunks = 6